import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormHelperText from '@material-ui/core/FormHelperText';

const useStyles = theme => ({
  root: {
    display: 'flex',
  },
  formControl: {
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(2)
  }
});

class CheckBox extends React.Component  {

  constructor(props) {
    super(props);
    this.state = {
      checkedItems: new Map()
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e){
    let item = e.target.name;
    let isChecked = e.target.checked;
    this.setState(prevState => ({
      checkedItems: prevState.checkedItems.set(item, isChecked)
    }), () => {
      this.props.handler(this.state.checkedItems);
    });

  };

  render(){
    const { classes } = this.props;
    let error = false;

    if(this.state.checkedItems.size === 0){
      error = true
    }else{
      let errorList = [];
      for (let [key, value] of this.state.checkedItems) {
        if(value == true){
          errorList.push(true)
        }
      }
      error = errorList.every( (val, i, arr) => val === false );
    }

    return (
      <div className={classes.root}>
        <FormControl component="fieldset" className={classes.formControl} required error={error}>
          <FormGroup>
            {
              this.props.list.map((option, index) => <FormControlLabel key={index} control={<Checkbox color="primary" name={option.id} onChange={this.handleChange} checked={this.state.checkedItems.get(option.id) ? this.state.checkedItems.get(option.id) : false } />} label={option.name} />
            )}
          </FormGroup>
          <FormHelperText>Choose at least one.</FormHelperText>
        </FormControl>
      </div>
    );
  }
}

export default withStyles(useStyles)(CheckBox);
